import React from "react";
import { motion } from "framer-motion";
import type { Tier } from "@commonTypes/tier";
import "./Subscribed.css";

interface Props {
  tier: Tier;
}

export const Subscribed: React.FC<Props> = ({ tier }) => {
  switch (tier) {
    case "gold":
      return <SubscribedGold />;
    case "platinum":
      return <SubscribedPlatinum />;
    case "rediculous":
      // TODO UPDATE
      return <SubscribedBasic />;
    case "ultimate":
      // TODO UPDATE
      return <SubscribedBasic />;
    default:
      return <SubscribedBasic />;
  }
};

const SubscribedGold: React.FC = () => {
  return (
    <motion.div
      className="text-7xl font-bold"
      initial={{ scale: 0.9 }}
      animate={{ scale: [1, 1.1, 1], opacity: [0.8, 1, 0.8] }}
      transition={{
        duration: 1.2,
        repeat: Infinity,
      }}
    >
      <div className="mb-6">
        <span data-heading="Subscribed" className="gold">
          Subscribed
        </span>
        <div className="text-sm">with Gold</div>
      </div>
    </motion.div>
  );
};

const SubscribedPlatinum: React.FC = () => {
  return (
    <motion.div
      className="text-7xl font-bold"
      initial={{ scale: 1.3 }}
      style={{ perspective: "10cm" }}
      animate={{
        rotateY: [0, 15, -15, 15, -15, 0], // 3D rotation back and forth along the Y-axis
      }}
      transition={{
        duration: 4,
        repeat: Infinity,
        repeatType: "loop", // Ensures the animation loops continuously
      }}
    >
      <div className="mb-6">
        <span data-heading="Subscribed" className="chrome">
          Subscribed
        </span>
        <div className="text-sm">with Platinum!</div>
      </div>
    </motion.div>
  );
};

const SubscribedBasic: React.FC = () => {
  return (
    <motion.div
      className="text-7xl font-bold"
      initial={{ scale: 0.9 }}
      animate={{ scale: [1, 1.1, 1], opacity: [0.8, 1, 0.8] }}
      transition={{
        duration: 1.2,
        repeat: Infinity,
      }}
    >
      <motion.div
        className={`text-green-500 mb-6 `}
        initial={{ rotate: -5 }}
        animate={{
          rotate: [0, -2, 2, -2, 0, 10, -4, 0, 0],
        }}
        transition={{ duration: 0.5, repeat: 1 }}
      >
        Subscribed
      </motion.div>
    </motion.div>
  );
};
